<template>
    <div class="row">
        <div class="form-group col-md-3">
            <label for="newQuestion" class="form-label">{{ _t('Question') }}</label>
            <input disabled v-model="text" type="text" id="newQuestion" class="form-control"/>
        </div>
        <div class="form-group col-md-3">
            <label class="form-label">{{ _t('Question type') }}</label>

            <select disabled v-model="type" class="form-control">
                <option disabled value="">{{ _t('Select...') }}</option>
                <option value="open">{{ _t('open') }}</option>
                <option value="number">{{ _t('number') }}</option>
                <option value="single_answer">{{ _t('single_answer') }}</option>
                <option value="multi_answer">{{ _t('multi_answer') }}</option>
            </select>
        </div>
        <div class="form-group col-md-3">
            <label class="form-label" for="sortOrder">{{ _t('Sort order') }}</label>

            <input disabled v-model="sortOrder" class="form-control" type="number" id="sortOrder">
        </div>
        <div class="form-group col-md-3">
            <label class="form-label" for="isRequiredCheckbox">{{ _t('Required answer') }}</label>

            <input disabled v-model="isRequired" class="checkbox" type="checkbox" id="isRequiredCheckbox">
        </div>
        <div class="form-group col-md-6">
            <img v-if="desktopImageUrl" :src="desktopImageUrl" class="mt-3 img-fluid">
            <div v-else>{{_t('No image')}}</div>
        </div>
        <div class="form-group col-md-6">
            <img v-if="mobileImageUrl" :src="mobileImageUrl" class="mt-3 img-fluid">
            <div v-else>{{_t('No image')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShowQuestion",
    props: [
        'text',
        'type',
        'sortOrder',
        'isRequired',
        'desktopImageUrl',
        'mobileImageUrl'
    ],
}
</script>

<style scoped>
img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/ShowQuestion.vue